export const SALARYHEADERMAPPING = {
    mapping: {
        "1": { "specialty": "HIV/AIDS", "specialist": "Infectious Disease Specialists" },
        "2": { "specialty": "Cardiology", "specialist": "Cardiologists" },
        "3": { "specialty": "HIV/Infectious Diseases", "specialist": "Infectious Disease Specialists" },
        "7": { "specialty": "Oncology", "specialist": "Oncologists" },
        "8": { "specialty": "Orthopedics", "specialist": "Orthopedic Surgeons" },
        "9": { "specialty": "Pediatrics", "specialist": "Pediatricians" },
        "12": { "specialty": "Psychiatry", "specialist": "Psychiatrists" },
        "13": { "specialty": "Pulmonary Medicine", "specialist": "Pulmonologists" },
        "14": { "specialty": "General Surgery", "specialist": "Surgeons" },
        "15": { "specialty": "Urology", "specialist": "Urologists" },
        "16": { "specialty": "Ob/Gyn & Women's Health", "specialist": "Obstetricians & Gynecologists" },
        "17": { "specialty": "Multispecialty", "specialist": "Physicians" },
        "18": { "specialty": "Internal Medicine", "specialist": "Primary Care Physicians" },
        "20": { "specialty": "Gastroenterology", "specialist": "Gastroenterologists" },
        "22": { "specialty": "Diabetes & Endocrinology", "specialist": "Diabetologists & Endocrinologists" },
        "26": { "specialty": "Neurology", "specialist": "Neurologists" },
        "27": { "specialty": "Rheumatology", "specialist": "Rheumatologists" },
        "32": { "specialty": "Critical Care", "specialist": "Critical Care Specialists" },
        "33": { "specialty": "Dermatology", "specialist": "Dermatologists" },
        "34": { "specialty": "Primary Care", "specialist": "Primary Care Physicians" },
        "35": { "specialty": "Radiology", "specialist": "Radiologists" },
        "36": { "specialty": "Ophthalmology", "specialist": "Ophthalmologists" },
        "38": { "specialty": "Allergy & Clinical Immunology", "specialist": "Allergists" },
        "42": { "specialty": "Public Health & Prevention", "specialist": "Public Health Specialists" },
        "43": { "specialty": "Pathology & Lab Medicine", "specialist": "Pathologists" },
        "44": { "specialty": "Nephrology", "specialist": "Nephrologists" },
        "45": { "specialty": "Emergency Medicine", "specialist": "Emergency Medicine Physicians" },
        "46": { "specialty": "Anesthesiology", "specialist": "Anesthesiologists" },
        "48": { "specialty": "Plastic Surgery & Aesthetic Medicine", "specialist": "Plastic Surgeons" },
        "50": { "specialty": "Primary Care", "specialist": "Primary Care Physicians" }
    }
}

// Keeping this data for fruther use
// "21": { "specialty": "Business of Medicine", "specialist": "-----" },
// "49": { "specialty": "Dental & Oral Health", "specialist": "-----" },
// "29": { "specialty": "Transplantation", "specialist": "-------" },
// "30": { "specialty": "Pharmacists", "specialist": "-------" },
// "24": { "specialty": "Nursing", "specialist": "-------" },
// "25": { "specialty": "Med Students", "specialist": "-------" },